import { Action } from '@ngrx/store';
import { User } from './user';

export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS';

export class UserAddAction implements Action {
  readonly type = USER_ADD_SUCCESS;

  constructor(public payload: User) {}
}

export type UserActions = UserAddAction;
